export function customerMessageContentForDisplay(
  content: string | null | undefined,
  contentRedacted: boolean | undefined,
): string {
  return contentRedacted ? 'Sensitive content hidden' : (content ?? '');
}
